import { EventType } from '@principle-theorem/principle-core/interfaces';
import {
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import { IPracticeScopedFact, ITimestampedFact } from './common';

export interface IScheduleSummaryEventFact
  extends IPracticeScopedFact,
    ITimestampedFact {
  day: ISerialisedTimestamp;
  stafferRef: ISerialisedDocumentReference;
  scheduleSummaryRef: ISerialisedDocumentReference;
  eventableSummaries: IScheduleSummaryEventableSummary[];
  preBlockSummaries: IScheduleSummaryPreBlockSummary[];
  rosterTimeInMins: number;
  revenueTotal: number;
  eventTimeInMins: number;
  appointmentTimeInMins: number;
  gapTimeInMins: number;
  totalRevenuePerHour: number;
  appointmentRevenuePerHour: number;
  revenueLostTotal: number;
}

export interface IScheduleSummaryEventableSummary
  extends Partial<IScheduleSummaryEventSummary>,
    Partial<IScheduleSummaryAppointmentSummary> {
  duration: number;
  eventFrom: ISerialisedTimestamp;
  eventTo: ISerialisedTimestamp;
}

export interface IScheduleSummaryEventSummary {
  type: EventType;
  duration: number;
  isBlocking: boolean;
}

export interface IScheduleSummaryAppointmentSummary {
  ref: ISerialisedDocumentReference;
  treatmentCategory: string;
  treatmentAmount: number;
}

export interface IScheduleSummaryPreBlockSummary {
  preBlockLabel: string;
  treatmentCategory: string[];
  treatmentAmount: string;
  utilisedPreBlockMins: number;
  unutilisedPreBlockMins: number;
  revenueLostTotal: number;
}
